import { filter } from 'lodash/fp';
import { parseInt } from '../../utils';

export default list =>
  filter(
    ({ isVisible = 1, enabled = true }) =>
      (isVisible === true || parseInt(isVisible) === 1) && enabled,
    list
  );
